import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morphProductBlock } from '@theme/morph';
import { Component } from '@theme/component';

/**
 * Studio Zuiver: free shipping line next to the price (blocks/_free-shipping-note.liquid).
 * Sizes can differ in price, so the line is morphed from the re-rendered section on every variant change.
 */
class FreeShippingNote extends Component {
  /** @type {Element | null} - Cached section/dialog the variant listener is attached to. */
  #variantUpdateTarget = null;

  connectedCallback() {
    super.connectedCallback();
    this.#variantUpdateTarget = this.closest('.shopify-section, dialog');
    this.#variantUpdateTarget?.addEventListener(ThemeEvents.variantUpdate, this.updateNote);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#variantUpdateTarget?.removeEventListener(ThemeEvents.variantUpdate, this.updateNote);
  }

  /**
   * Updates the note.
   * @param {VariantUpdateEvent} event - The variant update event.
   */
  updateNote = (event) => {
    morphProductBlock(this, event);
  };
}

if (!customElements.get('free-shipping-note')) {
  customElements.define('free-shipping-note', FreeShippingNote);
}
